module.exports = __webpack_public_path__ + "481e5ebc88601c33f7c5226578f8f0c8.jpg";